var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M396.432 0h-152.88C197.488 0 160 37.488 160 83.568V160H83.568C37.488 160 0 197.488 0 243.568v152.88C0 442.512 37.488 480 83.568 480h152.88C282.512 480 320 442.512 320 396.432V320h76.432c46.08 0 83.568-37.488 83.568-83.568V83.568C480 37.488 442.512 0 396.432 0zM288 396.432C288 424.88 264.88 448 236.432 448H83.568C55.12 448 32 424.88 32 396.432v-152.88C32 215.12 55.12 192 83.568 192H160v44.432c0 46.08 37.488 83.568 83.568 83.568H288v76.432zM288 288h-44.432C215.12 288 192 264.88 192 236.432V192h44.432C264.88 192 288 215.12 288 243.568V288zm160-51.568C448 264.88 424.88 288 396.432 288H320v-44.432c0-46.08-37.488-83.568-83.568-83.568H192V83.568C192 55.12 215.12 32 243.568 32h152.88C424.88 32 448 55.12 448 83.568v152.864z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopOut);
export default __webpack_public_path__ + "static/media/pop-out.fab2fc61f84760f04201fdf81117dc90.svg";
export { ForwardRef as ReactComponent };